import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';

export type ErrorBoundaryProps = {
  fallback: ReactNode | ((error: Error) => ReactNode);
  children: ReactNode;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps> {
  state = { error: null };

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info);
  }

  render() {
    if (this.state.error) {
      return typeof this.props.fallback === 'function' ? this.props.fallback(this.state.error) : this.props.fallback;
    }

    return this.props.children;
  }
}
